import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert, Button } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { csvUrl, getData, getInputParams } from '../CustomUtils'
import { TRIAL_DATE_REPORT_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ParameterValues from '../ParameterValues.js'
import ResultsGrid from '../ResultsGrid.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'

const TRIAL_DATE_REPORT = gql(TRIAL_DATE_REPORT_QUERY)

export default function TrialDateReport({ location }) {
  console.log('TrialDateReport rendered:', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [printView, setPrintView] = useState(false)
  const inputs = getInputParams(location) 

  useEffect(() => {
    if (inputs.printView) {
      delete inputs.printView
      location.search = `?inputs=${JSON.stringify(inputs)}`
      setPrintView(true)
    }
    getData(location, TRIAL_DATE_REPORT, 'trialDateReport', setResults, setGraphQLErrors)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  function printViewClicked() {
    inputs.printView = true
    const link = document.createElement('a')
    link.href = `/asbestos/nonav/custom/trial.trial_date_report?inputs=${JSON.stringify(inputs)}`
    link.setAttribute('target', '_blank')
    link.click()
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    let columnHeadings = <ColumnHeadings results={results} />
    let viewButtonDataIndex = results.reportData[0].length-1

    if (printView) {
      viewButtonDataIndex = null
      results.columnHeadings.splice(results.columnHeadings.length-1, 1)
      columnHeadings = <ColumnHeadings results={results} />
    }
    const resultRows = ResultsGrid(results, 0, viewButtonDataIndex, location, null, null, null, null, results.reportData[0].length-1)
    let drawPrintView = <Button color="primary" style={{marginRight: '10px'}} onClick={printViewClicked}>Printable View</Button>
    let drawCSV = <LargeRowHandler csvUrl={csvUrl('Asbestos/trialDateReport/trial_date_report', location)} resultsLength={results.reportData.length} />
    if (printView) {
      drawPrintView=''
      drawCSV = ''
    }
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          {drawPrintView}
          {drawCSV}
        </div>
        <Table bordered style={{backgroundColor: 'white'}} >
          <ReportHeading title={'Trial Date Report'} parameterValues={ParameterValues(results)} />
          <tbody>
            {columnHeadings}
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}